<template>
  <el-main>
    <router-view  @loading="setLoading($event)"></router-view>
  </el-main>
</template>
<script>
export default {
  methods: {
    setLoading (data) {
      this.$emit('loading', data)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/settings.scss";
</style>



// WEBPACK FOOTER //
// src/views/Layout/Content.vue